import {openDB, idb} from 'idb';
//import GlassbitHasher from "../security/GlassbitHasher.js";
//import moment from "moment";
import LZString from 'lz-string';


function toCatTickKey(gcid, catName)
{
    return "msa~" + gcid + "~" + catName.toLowerCase() + "~lastupdatedticks";
}

function toCatKey(gcid, catName)
{
    return "msa~" + gcid + "~" + catName.toLowerCase() + "~snap";
}

export default class LocalMasterDataService{
    constructor(){
        this.defaultObjectStore = "gcMaster";
        this.idb = {
            gcmDb: openDB("gcmDb", 1,{
                upgrade: (db, oldVersion, newVersion, transaction) => {
                    switch(oldVersion){
                        case 0:
                            
                             const store = db.createObjectStore('gcMaster');
                             store.createIndex("catalogType", "catalogType", {unique: true});
                            // fall through so that we can upgrade.
                        case 1:
                            break;
                        default:
                            console.log("unknown db version");
                    }

                }
            })
        };
    }

    
    async isLocalMasterCatalogOlder(gcid, catName, serverCatTicks)
    {
        try
        {
            var hasCatalogResult =  await this.hasMasterCatalog(gcid, catName);
            if (hasCatalogResult.hasError) return hasCatalogResult;
            if (!hasCatalogResult.dataResult) 
                // if there is no master catalog then it MUST be outdated
                return {"httpStatusCode": "", "hasError": false, "messages": ["Sucess"], "dataResult": true};

            var resultData = await (await this.idb.gcmDb).get("gcMaster", toCatTickKey(gcid, catName));
            var localCatTicks = resultData;
            console.log("ServerCatTicks: " + serverCatTicks);
            console.log("LocalCatTicks: " + localCatTicks);
            return {"httpStatusCode": "", "hasError": false, "messages": ["Success"], "dataResult": (serverCatTicks > localCatTicks)};
        }
        catch(err){
            return {"httpStatusCode": "", "hasError": true, "messages": ["Unexpected error checking for master catalog age in local storage", err.name, err.message], "dataResult": null};

        }
    }


    async hasMasterCatalog(gcid, catName)
    {
        try
        {
            var resultData = await (await this.idb.gcmDb).count("gcMaster", toCatKey(gcid, catName));
            return {"httpStatusCode": "", "hasError": false, "messages": ["Success"], "dataResult": (resultData>0)};
        }
        catch(err)
        {
            return {"httpStatusCode": "", "hasError": true, "messages": ["Unexpected error checking if master catalog is in local storage", err.name, err.message], "dataResult": null};
        }
    }

    async fetchMasterCatalog(gcid, catName, decompress=false)
    {
        try
        {
            var resultData = await (await this.idb.gcmDb).get("gcMaster", toCatKey(gcid, catName));
            if (decompress)
            {
                resultData = LZString.decompress(resultData);
            }
            var result = JSON.parse(resultData);
            return {"httpStatusCode": "", "hasError": false, "messages": ["Success"], "dataResult": result};
        }
        catch(err)
        {
            return {"httpStatusCode": "", "hasError": true, "messages": ["Unexpected error fetching master catalog from local storage", err.name, err.message], "dataResult": null};
        }
    }

    async addMasterCatalog(gcid, catName, cat, compress=false)
    {
        try
        {
        var lastUpdatedTicks = cat.lastUpdatedTicks;
        var catString = JSON.stringify(cat);
        await this.deleteMasterCatalog(gcid, catName);
        if (compress)
        {
            catString = LZString.compress(catString);
        }
        await (await this.idb.gcmDb).add("gcMaster", catString, toCatKey(gcid, catName));
        await (await this.idb.gcmDb).add('gcMaster', lastUpdatedTicks, toCatTickKey(gcid, catName));
        return {"httpStatusCode": "", "hasError": false, "messages": ["Success"], "dataResult": true};
        }
        catch(err)
        {
            return {"httpStatusCode": "", "hasError": true, "messages": ["Unexpected error adding master catalog to local storage", err.name, err.message], "dataResult": null};
        }
    }

    async deleteMasterCatalog(gcid, catName)
    {
        try
        {
            await (await this.idb.gcmDb).delete("gcMaster", toCatKey(gcid, catName));
            await (await this.idb.gcmDb).delete("gcMaster", toCatTickKey(gcid, catName));
            return {"httpStatusCode": "", "hasError": false, "messages": ["Success"], "dataResult": true};
        }
        catch(err)
        {
            return {"httpStatusCode": "", "hasError": true, "messages": ["Unexpected error deleting master catalog from local storage", err.name, err.message], "dataResult": null};
        }
    }











}



